import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import { Img } from 'assets/img';

export interface DireactionState {
  activeImgUrl: string;
}

const initialState: DireactionState = {
  activeImgUrl: Img.directionBuy1Url,
};

export const directionlice = createSlice({
  name: 'direction',
  initialState,
  reducers: {
    change: (state, action: PayloadAction<string>) => {
      state.activeImgUrl = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { change } = directionlice.actions;

export default directionlice.reducer;
